import { ActivityLogContainer } from 'components/order/activityLog/ActivityLogContainer';
import React, { useEffect } from 'react';
import { useSelectCurrentOrder } from 'selectors/order/selectCurrentOrder';
import { orderNavigationSlice } from 'store/order/orderNavigation/orderNavigationSlice';
import { useAppDispatch } from 'store/store';
import { IActivityQuery } from 'types/order/activities/IActivityQuery';
import { useQueryStringQuery } from 'pages/useQueryStringQuery';

export interface IActivityLogPageProps {}

export const ActivityLogPage: React.FC<IActivityLogPageProps> = () => {
  const { data: order } = useSelectCurrentOrder();
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(orderNavigationSlice.actions.setup({ tab: 'Activity' }));
  }, [dispatch, order.transaction.file_number]);

  const { queryKey, queryObject, setQueryObject } = useQueryStringQuery(
    'activity',
    {
      orderId: order.transaction.id!,
      sortBy: 'occurredAt.asc',
    } as IActivityQuery,
    ['orderId']
  );

  return <ActivityLogContainer queryKey={queryKey} queryObject={queryObject} setQueryObject={setQueryObject} />;
};
